import { Form, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../../components/action-bar";
import ActionButton from "../../../../components/action-button";
import useDispatchWithResult from "../../../../hooks/useDispatchWithResult";
import useLoading from "../../../../hooks/useLoading";
import { fetchProcurador, fetchProcuradores, procuradoreSelector } from "../../../../store/empresa";
import { valuesToFormData } from "../../../../util/formData";
import unwrapAxiosPromise from "../../../../util/unwrapAxiosPromise";
import EmpresaProcuradorForm from "./_form";
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaProcuradorEditPage() {
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const procurador = useSelector(procuradoreSelector);
  const loading = useLoading(fetchProcurador.typePrefix);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const { moduloBasePath } = useModulo();

useEffect(() => {
  if (!procurador) return;

  const parsedProcurador = {
    ...procurador,
    nomes:
      procurador.nomes?.map(item => {
        try {
          if (typeof item === "string") {
            const parsed = JSON.parse(item)
            if (parsed && parsed.nome) {
              return parsed;
            }
          }
          return typeof item === "string"
            ? { nome: item, cpf: "", email: "" }
            : item;
        } catch {
          return typeof item === "string"
            ? { nome: item, cpf: "", email: "" }
            : { nome: "", cpf: "", email: "" };
        }
      }) || [{ nome: "", cpf: "", email: "" }],
  };

  form.resetFields();
  form.setFieldsValue(parsedProcurador);

  setImmediate(() => document.querySelector("#tipo")?.focus());
}, [procurador]);



  const handleFinish = (values) => {
    setLoadingSave(true);
    const formData = valuesToFormData(values);
    unwrapAxiosPromise(axios.put(`/empresas/${empresaId}/procuradores/${id}`, formData), form)
      .then(() => {
        message.success(t("Registro alterado com sucesso"));
        history.replace(`${moduloBasePath}/empresas/${empresaId}/procuradores/${id}`);
        dispatch(fetchProcuradores({ empresaId }));
        dispatch(fetchProcurador({ empresaId, id }));
      })
      .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/procuradores/${id}`);
  };

  const title = (
    <ActionBar>
      <ActionButton.Save onClick={form.submit} loading={loadingSave} />
      <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
    </ActionBar>
  );

  return <EmpresaProcuradorForm disabled={loadingSave} form={form} loading={loading} onFinish={handleFinish} title={title} id={id} empresaId={empresaId} />;
}
